import { useEffect } from 'react'
import { teslaFleetAuthenticationCollection } from '@/reducers/teslaFleetAuthentication'
import { NavigationPage } from '@/app/components'
import { LoadingAnimation } from '@/components'
import { AlertMessage } from '@/app/components'
import Text from '@/components/Text/Text'

/**
 * This component is used to redirect the user to the Tesla Fleet Auth Redirect page.
 * It is used to handle the case where the user has no vehicles and needs to update their permissions.
 */
export default function TeslaFleetAuthRedirect() {
  const { data } = teslaFleetAuthenticationCollection.useFetch()
  const teslaFleetAuthUrl = data?.[0]?.authorize_url

  useEffect(() => {
    if (teslaFleetAuthUrl) {
      window.location.href = teslaFleetAuthUrl
    }
  }, [teslaFleetAuthUrl])

  return (
    <NavigationPage id="tesla-fleet-auth-redirect">
      <NavigationPage.SingleCardContent>
        <div className="flex flex-col items-center justify-center flex-grow w-full">
          <div className="flex flex-col items-center">
            <div className="flex justify-center pb-6">
              <LoadingAnimation type="falling" />
            </div>
            <Text variant="h3">
              Hold tight... we're reconnecting your Tesla account
            </Text>
            <div className="w-full py-6 mt-4">
              <AlertMessage variant="info" style={{ width: '100%' }}>
                This may take a moment
              </AlertMessage>
            </div>
          </div>
        </div>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
